import type { GetMeUserResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useOptionalUser() {
  const query = useQuery<GetMeUserResponse>({
    queryFn: () => apiClient.url("/users/me").get().json(),
    queryKey: ["user"],
    retry: false,
  });

  return {
    ...query,
    websiteUrl: query.data?.websiteUrl,
  };
}
